// CSVエスケープ
export const escapeCSV = (value) => {
    if (value === null || value === undefined) return '';
    const str = String(value);
    if (str.includes(',') || str.includes('"') || str.includes('\n')) {
        return '"' + str.replace(/"/g, '""') + '"';
    }
    return str;
};

// CSVパース（カンマ区切り・タブ区切り両対応）
export const parseCSV = (text) => {
    const lines = [];
    let current = '';
    let inQuotes = false;
    const rows = [];

    // 区切り文字を自動検出（最初の行でタブが多ければTSV）
    const firstLine = text.split(/\r?\n/)[0] || '';
    const tabCount = (firstLine.match(/\t/g) || []).length;
    const commaCount = (firstLine.match(/,/g) || []).length;
    const delimiter = tabCount > commaCount ? '\t' : ',';

    for (let i = 0; i < text.length; i++) {
        const char = text[i];
        if (inQuotes) {
            if (char === '"') {
                if (text[i + 1] === '"') {
                    current += '"';
                    i++;
                } else {
                    inQuotes = false;
                }
            } else {
                current += char;
            }
        } else {
            if (char === '"') {
                inQuotes = true;
            } else if (char === delimiter) {
                lines.push(current);
                current = '';
            } else if (char === '\n' || char === '\r') {
                if (char === '\r' && text[i + 1] === '\n') i++;
                lines.push(current);
                if (lines.length > 0) rows.push(lines.slice());
                lines.length = 0;
                current = '';
            } else {
                current += char;
            }
        }
    }
    if (current || lines.length > 0) {
        lines.push(current);
        rows.push(lines);
    }
    return rows;
};

// 日付を弥生形式に変換 (YYYY/MM/DD)
export const toYayoiDate = (dateStr) => {
    if (!dateStr) return '';
    const date = new Date(dateStr);
    return `${date.getFullYear()}/${String(date.getMonth() + 1).padStart(2, '0')}/${String(date.getDate()).padStart(2, '0')}`;
};

// 日付文字列をISO形式（YYYY-MM-DD）に変換
// 対応フォーマット: YYYY/MM/DD, YYYY-MM-DD, YYYY.MM.DD
export const fromYayoiDate = (dateStr) => {
    if (!dateStr) return '';
    // 既にISO形式（YYYY-MM-DD）の場合はそのまま返す
    if (/^\d{4}-\d{2}-\d{2}$/.test(dateStr)) {
        return dateStr;
    }
    // スラッシュ、ハイフン、ドット区切りに対応
    const parts = dateStr.split(/[\/\-\.]/);
    if (parts.length !== 3) return '';
    return `${parts[0]}-${parts[1].padStart(2, '0')}-${parts[2].padStart(2, '0')}`;
};
